import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Alert } from '../../core/models/alert.model';
import { MatTabsModule } from '@angular/material/tabs';
import { GeneralComponent } from '../general/general.component';
import { Constants } from '../../shared/utils/constants';
import { UpdateRecordService } from '../../core/services/update-record.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { UpdateRecord } from '../../core/models/update-record.model';
import { ModalComponent } from '../modal/modal.component';
import { PdfPreviewModalComponent } from '../pdf-preview-modal/pdf-preview-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmPopupComponent } from '../../shared/components/confirm-popup/confirm-popup.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ShiftClosureService } from '../../core/services/shift-closure.service';
import { AuthService } from '../../core/services/auth.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { lastValueFrom, map, forkJoin, firstValueFrom, of } from 'rxjs';
import { response } from 'express';
import { promises } from 'dns';
import { ShiftClosure } from '../../core/models/shift-closure.model';
import { StateSearchDTO, UpdateRecordSearchDTO } from '../../core/models/search-filter.model';

@Component({
  selector: 'app-shift-report',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatTableModule,
    MatTabsModule,
    GeneralComponent,
    ReactiveFormsModule,
    MatDialogModule,
    ConfirmPopupComponent,
    MatSnackBarModule,
    PdfPreviewModalComponent
  ],
  templateUrl: './shift-report.component.html',
  styleUrl: './shift-report.component.scss',
})
export class ShiftReportComponent implements OnInit {
  @Input() shiftClosureId!: number;
  pageTitle = 'Gestión de turnos > Informe Jefe de Turno';
  isPreviousView = false;
  alerts: Alert[] = [];
  shiftUpdates: any[] = [];
  shiftUpdatesByArea: any[] = [];
  seguridadCalidadMedioAmbiente: any[] = [];
  personalData: any[] = [];
  recordToClone: any | null = null;
  showConfirmPopup = false;
  showClonePopup = false;
  flattenedData: { [key: string]: any[] } = {
    [Constants.NOVEDADES]: [],
    [Constants.AVISO_AVERIAS]: [],
    [Constants.OT_EJECUTADAS]: [],
    [Constants.FUERA_SERVICIO]: [],
    [Constants.SEGURIDAD]: [],
    [Constants.PERSONAL]: [],
  };

  generalTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Novedad', field: 'novedad', width: '60%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  reportedBreakdownNoticeTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Prioridad', field: 'prioridad', width: '100px' },
    { header: '¿Qué está mal?', field: 'que_esta_mal', width: '15%' },
    { header: '¿Qué tiene de malo?', field: 'que_tiene_de_malo', width: '15%' },
    { header: 'Debería', field: 'deberia', width: '15%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  workOrderTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'N° Orden de Trabajo', field: 'n_orden', width: '140px' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '100px' },
    { header: 'Hora Inicio', field: 'hora_inicio', width: '100px' },
    { header: 'Hora Término', field: 'hora_termino', width: '100px' },
    { header: 'Hora Permiso Otorgado', field: 'hora_permiso', width: '150px' },
    { header: 'En Ejecución', field: 'en_ejecucion', width: '100px' },
    { header: 'Comentarios', field: 'comentarios', width: '30%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  outOfServiceTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Área', field: 'updateArea', width: '120px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Hora', field: 'hora', width: '100px' },
    { header: 'Novedad', field: 'ingrese_novedad', width: '60%' },
    // { header: 'Fecha', field: 'fecha', isDate: true },
  ];

  shiftUpdatesTableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '100px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Tipo', field: 'tipo_novedad', width: '120px' },
    { header: 'Novedad', field: 'detalleNovedad', width: '50%' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '100px' },
  ];

  // Columnas readonly (sin checkbox)
  generalTableColumnsRO: TableColumn[] = [];
  reportedBreakdownNoticeTableColumnsRO: TableColumn[] = [];
  workOrderTableColumnsRO: TableColumn[] = [];
  outOfServiceTableColumnsRO: TableColumn[] = [];
  shiftUpdatesTableColumnsRO: TableColumn[] = [];
  // Mostrar sección "Novedades del turno" (Seguridad / Personal) sólo si NO es operador DCS o Férrico
  showGeneralNewsSection: boolean = true;

  private toReadOnlyColumns(cols: TableColumn[]): TableColumn[] {
    return cols.filter(c => !c.isCheckbox);
  }

  //actualShiftClosure: ShiftClosure | null = null
  //previousShiftClosure: ShiftClosure | null = null


  //searchFilterShiftSupervisor: UpdateRecordSearchDTO = { type: '', areas: [], userScopeFilters: { searchUserId: 0 } };
  //searchFilterDCSOperator: UpdateRecordSearchDTO = { type: '', areas: [], userScopeFilters: { searchUserId: 0 } };
  //searchAreaOperator: UpdateRecordSearchDTO = { type: '', areas: [], userScopeFilters: { searchUserId: 0 } };

  isShiftSupervisor: boolean = false
  isDCSOperator: boolean = false
  isAreaOperator: boolean = false

  constructor(
    private updateRecordService: UpdateRecordService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private shiftClosureService: ShiftClosureService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) { }

  async ngOnInit(): Promise<void> {
    const paramId = this.route.snapshot.paramMap.get('shiftClosureId');
    if (paramId) this.shiftClosureId = +paramId

    this.isShiftSupervisor = this.authService.hasRole('novedades');
    this.isDCSOperator = this.authService.hasRole('Novedades_Operador_DCS');
    this.isAreaOperator = this.authService.hasRole('Novedades_Operador_Ferrico') || this.authService.hasRole('Novedades_Salmuera_I') || this.authService.hasRole('Novedades_Salmuera_II') || this.authService.hasRole('Novedades_Compresion') || this.authService.hasRole('Novedades_Electrolizadores') || this.authService.hasRole('Novedades_Subestacion') || this.authService.hasRole('Novedades_Movimiento_Producto');

    this.showGeneralNewsSection = !(this.isDCSOperator || this.isAreaOperator);

    // Determinar título dinámico según origen
    // Prioridad: state.flag -> queryParam 'mode' -> default
    try {
      const nav = this.router.getCurrentNavigation();
      const fromPrev = nav?.extras?.state && (nav.extras.state as any)['fromPreviousShift'];
      const mode = this.route.snapshot.queryParamMap.get('mode');
      this.isPreviousView = !!(fromPrev || mode === 'previous');
      if (this.isPreviousView) {
        this.pageTitle = 'Gestión de turnos > Novedades Turno Anterior';
      } else {
        this.pageTitle = this.buildShiftReportPageTitle();
      }
    } catch { }

    // Preparar columnas readonly
    this.generalTableColumnsRO = this.toReadOnlyColumns(this.generalTableColumns);
    this.reportedBreakdownNoticeTableColumnsRO = this.toReadOnlyColumns(this.reportedBreakdownNoticeTableColumns);
    this.workOrderTableColumnsRO = this.toReadOnlyColumns(this.workOrderTableColumns);
    this.outOfServiceTableColumnsRO = this.toReadOnlyColumns(this.outOfServiceTableColumns);
    this.shiftUpdatesTableColumnsRO = this.toReadOnlyColumns(this.shiftUpdatesTableColumns);

    if (this.shiftClosureId) return this.loadDataWithShiftClosureId() //para turno anterior
    if (this.isShiftSupervisor) return this.loadAndFilterByShiftSupervisor() //(JEFE DE TURNO)
    if (this.isDCSOperator) return this.loadAndFilterByDCSOperator() //(OPERADOR DCS) 
    if (this.isAreaOperator) return this.loadAndFilterByAreaOperator()//(OPERADOR DE ÁREA)


    // if (this.shiftClosureId) {
    //   this.loadDataWithShiftClosureId();
    // } else {
    //   this.loadData();
    //   this.loadDataByType(Constants.NOVEDADES); //id=10
    //   this.loadDataByType(Constants.AVISO_AVERIAS); //7
    //   this.loadDataByType(Constants.OT_EJECUTADAS);//8
    //   this.loadDataByType(Constants.FUERA_SERVICIO);//9
    //   this.loadDataByType(Constants.SEGURIDAD);//1
    //   this.loadDataByType(Constants.PERSONAL);//3
    // }


  }

  async loadDataWithShiftClosureId() {
    const filterSecurityType: UpdateRecordSearchDTO = { type: Constants.SEGURIDAD, areas: [Constants.GENERAL] }
    this.seguridadCalidadMedioAmbiente = await this.getPreviousShiftClosureForGeneralNewsSection(filterSecurityType) || []

    const filterPesonalType: UpdateRecordSearchDTO = { type: Constants.PERSONAL, areas: [Constants.GENERAL] }
    this.personalData = await this.getPreviousShiftClosureForGeneralNewsSection(filterPesonalType) || []

    const areas: string[] = this.getAreasByRole();
    const filter: UpdateRecordSearchDTO = { type: '', areas }
    const types: string[] = [
      Constants.NOVEDADES,
      Constants.AVISO_AVERIAS,
      Constants.OT_EJECUTADAS,
      Constants.FUERA_SERVICIO,
      Constants.SEGURIDAD,
      Constants.PERSONAL
    ]

    types.forEach(type => {
      filter.type = type
      this.getPreviousShiftClosure(filter)
    })

  }

  private async getPreviousShiftClosure(filter: UpdateRecordSearchDTO) {
    try {
      const type: string = filter.type
      const response: UpdateRecord[] = await firstValueFrom(this.updateRecordService.getPreviousShiftClosure(filter))
      if (response) {
        const flattened = this.flattenData(response);
        this.flattenedData[type] = flattened //flattened.length ? flattened : [];
      }
    } catch (err) {
      console.error('error en getPreviousShiftClosure', err)
    }
  }

  private async getPreviousShiftClosureForGeneralNewsSection(filters: UpdateRecordSearchDTO) {
    try {
      const response: UpdateRecord[] = await firstValueFrom(this.updateRecordService.getPreviousShiftClosure(filters))
      const flattened = this.flattenData(response)
      return flattened
    } catch (err) {
      console.error('error en getPreviousShiftClosureForGeneralNewsSection', err)
      return null
    }
  }

  private async loadAndFilterByShiftSupervisor() {
    this.getUpdateRecordsGeneralWithActualShiftClosure();

    const userId = this.authService.getUserId();
    const searchFilterShiftSupervisor: UpdateRecordSearchDTO= { 
      type: '', 
      areas: [], 
      userScopeFilters: { searchUserId: userId } 
    }

    searchFilterShiftSupervisor.areas = [
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ]

    const types: string[] = [
      Constants.NOVEDADES,
      Constants.AVISO_AVERIAS,
      Constants.OT_EJECUTADAS,
      Constants.FUERA_SERVICIO,
      Constants.SEGURIDAD,
      Constants.PERSONAL
    ]

    types.forEach(type => {
      const filter = { ... searchFilterShiftSupervisor, type }
      this.getByUpdateRecordSearch(filter)
    })

  }

  private async loadAndFilterByDCSOperator() {
    const userId = this.authService.getUserId();

    const searchFilterDCSOperator: UpdateRecordSearchDTO = { 
      type: '', 
      areas: [], 
      userScopeFilters: { searchUserId: userId } 
    };
    
    searchFilterDCSOperator.areas = [
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ]
    
    const types: string[] = [
      Constants.NOVEDADES,
      Constants.AVISO_AVERIAS,
      Constants.OT_EJECUTADAS,
      Constants.FUERA_SERVICIO
    ]

    types.forEach(type => {
      const filter = { ... searchFilterDCSOperator, type }
      this.getByUpdateRecordSearch(filter)
    })
  }

  private async loadAndFilterByAreaOperator() {
    //searchAreaOperator
    //solo ve su area
    const userId = this.authService.getUserId();
    const areas: string[] = this.getAreasByRole();
    
    const searchAreaOperator: UpdateRecordSearchDTO = { 
      type: '', 
      areas, 
      userScopeFilters: { searchUserId: userId } 
    };

    const types: string[] = [
      Constants.NOVEDADES,
      Constants.AVISO_AVERIAS,
      Constants.OT_EJECUTADAS,
      Constants.FUERA_SERVICIO
    ]

    types.forEach(type => {
      const filter = { ... searchAreaOperator, type }
      this.getByUpdateRecordSearch(filter)
    })
  }

  private async getByUpdateRecordSearch(filter: UpdateRecordSearchDTO) {
    const type = filter.type
    try {
      const response = await firstValueFrom(this.updateRecordService.getUpdateRecordsPost(filter))
      const flattened = this.flattenData(response);
      this.flattenedData[type] = flattened.length ? flattened : [];
    } catch (error) {
      console.error('error buscarPorPOST:', error)
    }

  }

  private getUpdateRecordsGeneralWithActualShiftClosure() {

    const userId = this.authService.getUserId();
    this.updateRecordService.getUpdateRecordsGeneral(undefined, false, userId!).subscribe(response => {

      this.seguridadCalidadMedioAmbiente = this.flattenData(response.filter(item =>
        item.updateType?.name?.toLowerCase().includes('seguridad') ||
        item.updateType?.name?.toLowerCase().includes('calidad') ||
        item.updateType?.name?.toLowerCase().includes('medio ambiente')
      ));

      this.personalData = this.flattenData(response.filter(item =>
        item.updateType?.name?.toLowerCase() === 'personal'
      ));

    })
  }




  /**
   * Construye el título de la página según el rol del usuario.
   * - DCS o Novedades (acceso completo): "Gestión de turnos > Informe Jefe de Turno"
   * - Operadores (férrico-like): "Gestión de turnos > Informe Operador [Área]"
   */
  private buildShiftReportPageTitle(): string {
    const prefix = 'Gestión de turnos > ';
    const isFull = this.authService.hasRole('novedades');
    if (isFull) {
      return `${prefix}Informe Jefe de Turno`;
    }

    // Map de roles a nombres de área legibles
    const areaMap: { [role: string]: string } = {
      'Novedades_Operador_Ferrico': 'Cloruro férrico',
      'Novedades_Salmuera_I': 'Salmuera I',
      'Novedades_Salmuera_II': 'Salmuera II',
      'Novedades_Compresion': 'Compresión',
      'Novedades_Electrolizadores': 'Electrolizadores',
      'Novedades_Subestacion': 'Subestación',
      'Novedades_Movimiento_Producto': 'Movimiento de productos',
      'Novedades_Operador_DCS': 'DCS'
    };

    for (const role in areaMap) {
      if (this.authService.hasRole(role)) {
        return `${prefix}Informe Operador ${areaMap[role]}`;
      }
    }

    // Fallback (caso no reconocido)
    return `${prefix}Informe de Turno`;
  }

  loadData(): void {
    const userId = this.authService.getUserId();

    // Carga los datos generales
    this.updateRecordService
      .getUpdateRecordsByAreas([Constants.GENERAL], undefined, undefined, false, true, userId ?? undefined)
      .subscribe({
        next: (updates: UpdateRecord[]) => {
          this.shiftUpdates = this.flattenData(updates) || [];
          this.filterDataByType();
          this.cdr.detectChanges();
        },
        error: error => {
          console.error(`Error al cargar los datos para el área ${Constants.GENERAL}:`, error);
          this.shiftUpdates = [];
          this.filterDataByType();
          this.cdr.detectChanges();
        },
      });

    // Carga los datos de las áreas específicas
    this.updateRecordService
      .getUpdateRecordsByAreas(
        [
          Constants.CLORURO_FERRICO,
          Constants.SALMUERA_I,
          Constants.SALMUERA_II,
          Constants.COMPRESION,
          Constants.ELECTROLIZADORES,
          Constants.SUBESTACION,
          Constants.MOVIMIENTO_PRODUCTO,
          Constants.DCS,
        ],
        undefined, undefined, false, false, userId ?? undefined
      )
      .subscribe({
        next: (updates: UpdateRecord[]) => {
          this.shiftUpdatesByArea = this.flattenData(updates) || [];
          this.cdr.detectChanges();
        },
        error: error => {
          console.error('Error al cargar los datos de las áreas:', error);
          this.shiftUpdatesByArea = []; // Asegurar lista vacía en caso de error
          this.cdr.detectChanges();
        },
      });
  }

  loadDataByTypeDCS(type: string): void {
    this.updateRecordService
      .getUpdateRecordsByTypeAndAreasDCS(type)
      .subscribe({
        next: (updates: UpdateRecord[]) => {
          //const updatesFilterByDate = this.filterByShiftClosureDate(this.actualShiftClosure!, updates)
          const flattened = this.flattenData(updates);
          this.flattenedData[type] = flattened.length ? flattened : [];
        },
        error: error => {
          if (error.status === 404) {
            this.flattenedData[type] = [];
          } else {
            console.error(`Error al cargar los datos para el tipo ${type}:`, error);
            this.flattenedData[type] = [];
          }
        },
      });
  }


  loadDataByType(type: string): void {

    // Define las áreas que deseas pasar al servicio
    const areas: string[] = [
      Constants.GENERAL,
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ];
    const isMarkedForClosure = undefined;
    const isMarkedForPreClosure = false;
    const forceUserScope = false;
    const userId = this.authService.getUserId();

    this.updateRecordService
      .getUpdateRecordsByTypeAndAreas(
        type,
        areas,
        undefined,
        isMarkedForClosure,
        isMarkedForPreClosure,
        forceUserScope,
        undefined,//userId ?? undefined,
        //this.isRoleNovedades_Operador_DCS
      )
      .subscribe({
        next: (updates: UpdateRecord[]) => {
          //const updatesFilterByDate = this.filterByShiftClosureDate(this.actualShiftClosure!, updates)
          const flattened = this.flattenData(updates);
          this.flattenedData[type] = flattened.length ? flattened : [];
        },
        error: error => {
          if (error.status === 404) {
            this.flattenedData[type] = [];
          } else {
            console.error(`Error al cargar los datos para el tipo ${type}:`, error);
            this.flattenedData[type] = [];
          }
        },
      });
  }



  /**
   * Obtiene las áreas a consultar según el rol del usuario.
   * - 'novedades' (jefe turno): todas las áreas
   * - Operadores específicos: solo su área correspondiente
   */
  private getAreasByRole(): string[] {
    // Si es jefe de turno, retorna todas las áreas
    if (this.authService.hasRole('novedades')) {
      return [
        Constants.CLORURO_FERRICO,
        Constants.SALMUERA_I,
        Constants.SALMUERA_II,
        Constants.COMPRESION,
        Constants.ELECTROLIZADORES,
        Constants.SUBESTACION,
        Constants.MOVIMIENTO_PRODUCTO,
        Constants.DCS,
      ];
    }

    // Operadores específicos: retornar solo su área
    if (this.authService.hasRole('Novedades_Operador_Ferrico')) {
      return [Constants.CLORURO_FERRICO];
    }

    if (this.authService.hasRole('Novedades_Operador_DCS')) {
      //return [Constants.DCS];
      return [
        Constants.CLORURO_FERRICO,
        Constants.SALMUERA_I,
        Constants.SALMUERA_II,
        Constants.COMPRESION,
        Constants.ELECTROLIZADORES,
        Constants.SUBESTACION,
        Constants.MOVIMIENTO_PRODUCTO,
        Constants.DCS,
      ];
    }

    if (this.authService.hasRole('Novedades_Salmuera_I')) {
      return [Constants.SALMUERA_I];
    }

    if (this.authService.hasRole('Novedades_Salmuera_II')) {
      return [Constants.SALMUERA_II];
    }

    if (this.authService.hasRole('Novedades_Compresion')) {
      return [Constants.COMPRESION];
    }

    if (this.authService.hasRole('Novedades_Electrolizadores')) {
      return [Constants.ELECTROLIZADORES];
    }

    if (this.authService.hasRole('Novedades_Subestacion')) {
      return [Constants.SUBESTACION];
    }

    if (this.authService.hasRole('Novedades_Movimiento_Producto')) {
      return [Constants.MOVIMIENTO_PRODUCTO];
    }

    // Por defecto, si no se reconoce el rol, retornar todas las áreas
    return [
      Constants.CLORURO_FERRICO,
      Constants.SALMUERA_I,
      Constants.SALMUERA_II,
      Constants.COMPRESION,
      Constants.ELECTROLIZADORES,
      Constants.SUBESTACION,
      Constants.MOVIMIENTO_PRODUCTO,
      Constants.DCS,
    ];
  }

  // Determina la marca de cierre a mostrar según rol y/o área del registro
  private getRoleSpecificClosureMark(update: UpdateRecord): boolean {
    const u: any = update as any;
    const isDcs = this.authService.hasRole('Novedades_Operador_DCS') || this.authService.hasRole('DCS') || this.authService.hasRole('dcs');
    const isFerrico = this.authService.hasRole('Novedades_Operador_Ferrico') || this.authService.hasRole('Novedades_Salmuera_I') || this.authService.hasRole('Novedades_Salmuera_II') || this.authService.hasRole('Novedades_Compresion') || this.authService.hasRole('Novedades_Electrolizadores') || this.authService.hasRole('Novedades_Subestacion') || this.authService.hasRole('Novedades_Movimiento_Producto') || this.authService.hasRole('FERRICO') || this.authService.hasRole('ferrico');
    if (isDcs) {
      return (u.isMarkedForClosureDCS ?? u.isMarkedForClosureDcs ?? update.isMarkedForClosure) as boolean;
    }
    if (isFerrico) {
      return (u.isMarkedForClosureFerrico ?? update.isMarkedForClosure) as boolean;
    }
    return update.isMarkedForClosure;
  }

  flattenData(updates: UpdateRecord[]): any[] {
    return updates.flatMap(update => {
      const elements = update.updateElements;
      const getElementValue = (label: string): string =>
        elements.find(el => el.label === label)?.updateValues?.[0]?.value || '';
      const createdByUser = elements?.find(el => el.element?.id === 2 || el.element?.id === 5)
        ?.updateValues?.[0]?.createdUser;
      const responsibleId = (update as any)?.responsible?.id ?? createdByUser?.id ?? null;

      const hora = getElementValue('Hora');
      const novedad = getElementValue('Novedad');
      const tipoNovedad = getElementValue('Tipo de Novedad');
      const prioridad = getElementValue('Prioridad');
      const queEstaMal = getElementValue('¿Qué está mal?');
      const queTieneDeMalo = getElementValue('¿Qué tiene de malo?');
      const deberia = getElementValue('Debería');
      const nOrden = getElementValue('N° Orden de Trabajo');
      const horaInicio = getElementValue('Hora Inicio');
      const horaTermino = getElementValue('Hora Término');
      const horaPermiso = getElementValue('Hora Permiso Otorgado');
      const enEjecucion = getElementValue('En Ejecución');
      const comentarios = getElementValue('Comentarios');
      const horaFueraServicio = getElementValue('Hora Fuera de Servicio');
      const ingreseNovedad = getElementValue('Ingrese Novedad');


      // Solo los valores sin los labels
      const detalleNovedad = elements
        .filter(el => el.label !== 'Hora' && el.label !== 'Tipo de Novedad')
        .map(el => el.updateValues?.map(val => val.value).join(', ') || '')
        .filter(txt => txt.trim() !== '')
        .join(', ');

      return {
        id: update.id,
        hora,
        hora_inicio: horaInicio,
        hora_termino: horaTermino,
        hora_permiso: horaPermiso,
        hora_fuera_servicio: horaFueraServicio,
        ingrese_novedad: ingreseNovedad,
        en_ejecucion: enEjecucion === "true" ? "Si" : "No",
        n_orden: nOrden,
        prioridad,
        que_esta_mal: queEstaMal,
        que_tiene_de_malo: queTieneDeMalo,
        deberia,
        responsable: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUser?.username || '',
        createdById: createdByUser?.id ?? elements?.[0]?.updateValues?.[0]?.createdUser?.id ?? null,
        responsibleId,
        tipo_novedad: tipoNovedad ? tipoNovedad : update.updateType?.name,
        tipo: update.updateType?.name,
        area: update.updateArea?.name,
        updateArea: update.updateArea?.name,
        novedad: novedad,
        detalleNovedad,
        comentarios,
        fecha: elements.find(el => el.element?.id === 2 || el.element?.id === 5)?.updateValues?.[0]?.createdUtc || '',
        updateElements: elements,
        updateType: update.updateType,
        isMarkedForClosure: this.getRoleSpecificClosureMark(update),
        isMarkedForPreClosure: update.isMarkedForPreClosure,
        isCloned: update.isCloned,
      };
    });
  }

  filterDataByType(): void {
    if (!this.shiftClosureId) return console.log('no hay shiftClosureId filterDataByType que llena seguridadCalidadMedioAmbiente y personalData se anula y reemplaza por endpoint alternativo')//acaa
    this.seguridadCalidadMedioAmbiente = this.shiftUpdates.filter(item =>
      item.updateType?.name?.toLowerCase().includes('seguridad') ||
      item.updateType?.name?.toLowerCase().includes('calidad') ||
      item.updateType?.name?.toLowerCase().includes('medio ambiente')
    );

    this.personalData = this.shiftUpdates.filter(item =>
      item.updateType?.name?.toLowerCase() === 'personal'
    );

    console.log('Total shiftUpdates:', this.shiftUpdates.length);
    console.log('Seguridad/Calidad/Medio Ambiente items:', this.seguridadCalidadMedioAmbiente.length);
    console.log('Personal items:', this.personalData.length);
    console.log('ShiftUpdates data:', this.shiftUpdates);
  }


  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  viewUpdateRecord(updateRecord: UpdateRecord): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar el objeto directamente
        readOnly: true, // Abrir en modo solo lectura
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  async shiftClosure(): Promise<void> {
    const response = await lastValueFrom(
      this.shiftClosureService.getOpenShiftByType(Constants.INFORME_TURNO)
    );
    const shiftClosureId = response;
    if (shiftClosureId === undefined || shiftClosureId === null) {
      console.error('No se encontró un turno abierto.');
      return;
    }
    // Seleccionar tipo/área según rol
    const { type, area } = this.getShiftReportTypeAndAreaByRole();
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        type,
        area,
        shiftClosureId: shiftClosureId,
        skipPreview: true // Saltar paso de previsualización PDF
      },
      width: '800px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean, error?: any } | undefined) => {
      if (result?.success) {
        console.log('Modal cerrado con éxito. Recargando datos...');
      } else {
        console.log('Modal cerrado sin acción.');
        // const errorMessage = result?.error?.error || 'Ocurrió un error inesperado.';
        // this.snackBar.open(`Error al generar informe: ${errorMessage}`, 'Cerrar', { duration: 5000 });
      }
      this.ngOnInit();
    });
  }

  async openPdfPreview() {
    try {
      // Primero obtenemos el ID del turno abierto actual
      const response = await lastValueFrom(
        this.shiftClosureService.getOpenShiftByType(Constants.INFORME_TURNO)
      );
      const shiftClosureId = response;

      if (shiftClosureId === undefined || shiftClosureId === null) {
        this.snackBar.open('No se encontró un turno abierto para previsualizar.', 'Cerrar', { duration: 3000 });
        return;
      }

      // Cargar primero los datos actuales para no perder los valores
      const currentFormValues = await this.getCurrentFormValues(shiftClosureId);

      // Abrir el modal con el flujo de stepper para informe de turno
      const { type, area } = this.getShiftReportTypeAndAreaByRole();
      const dialogRef = this.dialog.open(ModalComponent, {
        data: {
          type,
          area,
          readOnly: false,
          shiftClosureId: shiftClosureId,
          isPreviewMode: true, // Modo previsualización automática
          currentFormValues: currentFormValues // Pasar los valores actuales del formulario
        },
        minWidth: '50%',
        minHeight: '20%',
        maxWidth: '1200px',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.success && !result?.previewOpened) {
          this.loadData(); // Solo recargar datos si fue un cierre completo, no solo previsualización
        }
      });
    } catch (error) {
      console.error('Error al abrir la previsualización PDF:', error);
      this.snackBar.open('Error al obtener el turno abierto.', 'Cerrar', { duration: 3000 });
    }
  }

  /**
   * Obtiene los valores actuales del formulario para el turno especificado
   */
  async getCurrentFormValues(shiftClosureId: number): Promise<any> {
    try {
      // Obtener los datos actuales del registro
      const records = await lastValueFrom(
        this.updateRecordService.getUpdateRecordsByShiftClosureAndArea(
          shiftClosureId,
          [this.getShiftReportTypeAndAreaByRole().area]
        )
      );

      if (records && records.length > 0) {
        // Transformar los datos a un formato que pueda ser utilizado por el formulario
        const formValues: { [key: string]: any } = {};

        // Procesar cada elemento del registro y guardar sus valores
        records[0].updateElements.forEach(element => {
          if (element.updateValues && element.updateValues.length > 0) {
            const value = element.updateValues[0].value;
            // Solo guardar valores que no sean '0'
            if (value !== '0' && value !== '') {
              formValues[element.id.toString()] = value;
              console.log(`Saving form value for field ${element.id}: ${value}`);
            }
          }
        });

        return formValues;
      }

      return {}; // Retornar objeto vacío si no hay datos
    } catch (error) {
      console.error('Error al obtener los valores actuales del formulario:', error);
      return {};
    }
  }

  /**
   * Determina el tipo y el área del informe de turno según el rol del usuario.
   */
  private getShiftReportTypeAndAreaByRole(): { type: string; area: string } {
    if (this.authService.hasRole('Novedades_Operador_DCS')) {
      return { type: Constants.TIPO_CIERRE_TURNO_DCS, area: Constants.DCS };
    }
    if (this.authService.hasRole('Novedades_Operador_Ferrico')) {
      // AREA_FERRICO apunta ahora a 'cloruro_ferrico' (ajuste requerido por backend)
      return { type: Constants.TIPO_CIERRE_TURNO_FERRICO, area: Constants.AREA_FERRICO };
    }
    if (this.authService.hasRole('Novedades_Salmuera_II')) {
      // Tipo específico para Salmuera II, con su propia área
      return { type: Constants.TIPO_CIERRE_TURNO_SALMUERA_II, area: Constants.SALMUERA_II };
    }
    if (this.authService.hasRole('Novedades_Salmuera_I')) {
      // Tipo específico para Salmuera I, con su propia área
      return { type: Constants.TIPO_CIERRE_TURNO_SALMUERA_I, area: Constants.SALMUERA_I };
    }
    if (this.authService.hasRole('Novedades_Electrolizadores')) {
      // Tipo específico para Electrolizadores, con su propia área
      return { type: Constants.TIPO_CIERRE_TURNO_ELECTROLIZADORES, area: Constants.ELECTROLIZADORES };
    }
    if (this.authService.hasRole('Novedades_Subestacion')) {
      // Tipo específico para Subestación, con su propia área
      return { type: Constants.TIPO_CIERRE_TURNO_SUBESTACION, area: Constants.SUBESTACION };
    }
    if (this.authService.hasRole('Novedades_Movimiento_Producto')) {
      // Tipo específico para Movimiento de Producto, con su propia área
      return { type: Constants.TIPO_CIERRE_TURNO_MOVIMIENTO_PRODUCTO, area: Constants.MOVIMIENTO_PRODUCTO };
    }
    if (this.authService.hasRole('Novedades_Compresion')) {
      // Tipo específico para Compresión, con su propia área
      return { type: Constants.TIPO_CIERRE_TURNO_COMPRESION, area: Constants.COMPRESION };
    }
    // Por defecto perfil 'novedades' u otros: informe diario general
    return { type: Constants.TIPO_CIERE_TURNO_INFORME_DIARIO, area: Constants.AREA_CIERRE_TURNO };
  }

  onCheckboxChangeForClosure(isMarked: boolean, updateRecordId: number): void {
    this.updateRecordService.updateMarkForClosure(updateRecordId, isMarked).subscribe({
      next: () => {
        console.log('Estado actualizado correctamente.');
      },
      error: (error) => {
        console.error('Error al actualizar el estado:', error);
      },
    });
  }

  onCheckboxChangeForPreClosure(isMarked: boolean, updateRecordId: number): void {
    this.updateRecordService.updateMarkForPreClosure(updateRecordId, isMarked).subscribe({
      next: () => {
        console.log('Estado actualizado correctamente.');
      },
      error: (error) => {
        console.error('Error al actualizar el estado:', error);
      },
    });
  }

  openCloneConfirmation(record: any): void {
    this.recordToClone = record;
    this.showClonePopup = true;
  }

  closeClonePopup(): void {
    this.showClonePopup = false;
    this.recordToClone = null;
  }

  confirmClone(): void {
    if (!this.recordToClone) {
      console.error('No hay registro para clonar.');
      return;
    }

    this.updateRecordService.cloneUpdateRecord(this.recordToClone.id).subscribe({
      next: clonedRecord => {
        console.log('Registro clonado exitosamente:', clonedRecord);
        this.ngOnInit();
        this.closeClonePopup();
        this.router.navigate(['/shift-report']);
      },
      error: err => {
        this.snackBar.open(
          err?.error || 'Ocurrió un error al clonar turno.',
          'Cerrar',
          { duration: 3000 }
        );
        console.error('Error al clonar el registro:', err);
      },
    });

    console.log("shiftUpdatesByArea: ", this.shiftUpdatesByArea);
  }

  editUpdateRecord(updateRecord: any): void {
    if (!updateRecord.updateElements) {
      console.error('El objeto no tiene elementos de actualización:', updateRecord);
      return;
    }

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar los datos del registro
        readOnly: false, // Permitir edición
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        console.log('Edición realizada con éxito. Actualizando datos...');
        this.ngOnInit();
      }
    });
  }

  deleteUpdateRecord(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: '¿Estás seguro de que deseas eliminar este registro?' },
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.updateRecordService.deleteUpdateRecord(id).subscribe({
          next: () => {
            console.log(`Registro con ID ${id} eliminado correctamente.`);
            this.ngOnInit();
          },
          error: error => {
            console.error(`Error al eliminar el registro con ID ${id}:`, error);
          },
        });
      }
    });
  }

  canDelete(item: any): boolean {
    const uid = this.authService.getUserId();
    if (!uid) return false;
    if (typeof item?.responsibleId === 'number') {
      return item.responsibleId === uid;
    }
    return item?.createdById === uid;
  }

  openConfirmPopup(): void {
    this.showConfirmPopup = true; // Mostrar el popup de confirmación
  }

  closeConfirmPopup(): void {
    this.showConfirmPopup = false; // Ocultar el popup de confirmación
  }

  confirmStartShift(): void {
    this.closeConfirmPopup(); // Cerrar el popup antes de iniciar el turno

    const payload = { shiftClosureType: 'informe_turno' };
    this.shiftClosureService.startShift(payload).subscribe({
      next: (response) => {
        this.snackBar.open('Turno iniciado exitosamente.', 'Cerrar', { duration: 3000 });
        console.log('Turno iniciado:', response);
      },
      error: (err) => {
        console.error('Error al iniciar el turno:', err);
        this.snackBar.open(
          err?.error || 'Ocurrió un error al iniciar el turno.',
          'Cerrar',
          { duration: 3000 }
        );
      },
    });
  }

  goToPreviousShift(): void {
    this.shiftClosureService.getPreviousShiftIdByType(Constants.INFORME_TURNO).subscribe({
      next: (prevId: number) => {
        this.router.navigate(['/shift-report', prevId], {
          state: { fromPreviousShift: true },
          queryParams: { mode: 'previous' }
        });
      },
      error: (err) => {
        console.error('Error al obtener el turno anterior:', err);
      }
    });
  }

  goToMyNews(): void {
    this.router.navigate(['/shift-report']);
  }

  onSelectAllChange(event: { checked: boolean; type: string; visibleData?: any[] }): void {
    const isChecked = event.checked;
    const tableType = event.type;

    let dataArray: any[] = [];

    // Si se proporcionan los datos visibles, usar esos. Si no, usar todos los datos.
    if (event.visibleData && event.visibleData.length > 0) {
      dataArray = event.visibleData;
    } else {
      // Determinar qué array de datos actualizar según el tipo de tabla (comportamiento anterior)
      switch (tableType) {
        case 'seguridad_calidad':
          dataArray = this.seguridadCalidadMedioAmbiente || [];
          break;
        case 'personal':
          dataArray = this.personalData || [];
          break;
        case 'novedades':
          dataArray = this.flattenedData['novedades'] || [];
          break;
        case 'aviso_averias':
          dataArray = this.flattenedData['aviso_averias'] || [];
          break;
        case 'o_t_ejecutadas':
          dataArray = this.flattenedData['o_t_ejecutadas'] || [];
          break;
        case 'fuera_servicio':
          dataArray = this.flattenedData['fuera_servicio'] || [];
          break;
        default:
          console.warn('Tipo de tabla no reconocido:', tableType);
          return;
      }
    }

    // Si no hay datos, salir
    if (!dataArray || dataArray.length === 0) {
      console.warn('No hay datos para actualizar en el tipo de tabla:', tableType);
      return;
    }

    // Filtrar solo los elementos que realmente necesitan cambio de estado
    const itemsToUpdate = dataArray.filter((item: any) => {
      return item && item.id && item.isMarkedForClosure !== isChecked;
    });

    if (itemsToUpdate.length === 0) {
      console.log('Todos los elementos visibles ya tienen el estado deseado.');
      return;
    }

    // Actualizar visualmente solo los elementos que van a cambiar
    itemsToUpdate.forEach((item: any) => {
      item.isMarkedForClosure = isChecked;
    });

    // Realizar las llamadas a la API solo para los elementos que cambiaron
    const requests = itemsToUpdate.map((item: any) =>
      this.updateRecordService.updateMarkForClosure(item.id, isChecked)
    );

    // Usar forkJoin para manejar múltiples solicitudes en paralelo
    forkJoin(requests).subscribe({
      next: () => {
        console.log(`Se actualizaron ${requests.length} registros visibles correctamente en la tabla ${tableType}.`);
      },
      error: (error) => {
        console.error('Error al actualizar algunos registros:', error);

        // En caso de error, revertir los cambios visuales solo en los elementos que se intentaron cambiar
        itemsToUpdate.forEach((item: any) => {
          item.isMarkedForClosure = !isChecked;
        });
      }
    });
  }
}




